import { createAsyncAction } from 'typesafe-actions';
import { ResetPasswordDto } from './resetPassword.dtos';

export const resetPasswordActions = createAsyncAction(
  'RESET_PASSWORD_REQUEST',
  'RESET_PASSWORD_SUCCESS',
  'RESET_PASSWORD_ERROR',
)<ResetPasswordDto, string, string>();